import { render } from "./MsisdnClassSettings.vue?vue&type=template&id=5d570f5b"
import script from "./MsisdnClassSettings.vue?vue&type=script&lang=js"
export * from "./MsisdnClassSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__